import { createStore } from 'vuex'

import Api from './modules/api.js'
import App from './modules/app.js'
import Appointment from './modules/appointment.js'
import Business from './modules/business.js'
import CashRegister from './modules/cash-register.js'
import Identity from './modules/identity.js'
import RoutingConfig from './modules/routing-config.js'
import Subscription from './modules/subscription.js'

import AttachableIndex from './modules/ui/attachable-index.js'
import Overlay from './modules/ui/overlay.js'
import LoadingScreen from './modules/ui/loading-screen.js'

const debug = process.env.NODE_ENV !== 'production'

export const store = createStore({
  strict: debug,
  modules: {
    app: App,
    appointment: Appointment,
    api: Api,
    business: Business,
    cashRegister: CashRegister,
    identity: Identity,
    routingConfig: RoutingConfig,
    attachableIndex: AttachableIndex,
    overlay: Overlay,
    loadingScreen: LoadingScreen,
    subscription: Subscription,
  },
})
